
export {DecodeHtmlEntitiesModule } from './decode.module';
export {DecodeHtmlEntities} from './decode-html-entities.Pipe';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
